import React,{useState,useEffect, useRef} from 'react'
import authQueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import CustomCheckbox from '../../common/CustomCheckbox';
import {Accordion, AccordionItem} from "@nextui-org/react";
import { Spin, } from 'antd';
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const Step3 = ({setCurrent, current, setCurrentTab, currentTab, navTab, setNavTab}) => {
    
    const { formData, updateFormData } = useFormContext();

    const categoryOtherRef = useRef(null);

    const [result, setResult] = useState([]);

    const [category, setCategory] = useState([])

    const [isVisible, setIsVisible] = useState(false)

    const [activeIndex, setActiveIndex] = useState(null);

    const [loading, setLoading] = useState(false);

    const [cateData, setCateData] = useState("");

    const { register, reset, control, handleSubmit, formState: { errors }, setError} = useForm({});


  useEffect(() => {
    setLoading(true)
    onSubmit();
  }, []);

     


    const CateList = authQueries.useCategoryListMutation(

      (response) => {

        setLoading(false)
        setResult(response?.data?.items)

      }
      
    );
  
    const onSubmit = () =>{
      CateList.mutateAsync()
    };

    const categorySubmit = () => {

      if(!cateData && isVisible){

        alert('Please fill Others')

        setLoading(false)
  
        return setError('category_other', {type: 'custom', message: 'Other Category is Required'})
        
      }

        const updatedFormData = {
            ...formData,
            category: category, 
          };
      
          updateFormData(updatedFormData);
     
      if(category.length == ''){
        alert("Please select at least one category")
        return false
      }
      else{
        setNavTab(navTab + 1)
        setCurrent(current + 1)
      }

      
    };


    const handleClick = (index) => {
      if (index === activeIndex) {
        setActiveIndex(null);
      } else {
        setActiveIndex(index);
      }
    };

    const CategoryHandler = (e) => {
  
      const inputText = e.target.value
  
      setCateData(inputText)
      
      updateFormData({ category_other: e.target.value })

      if (inputText.toLowerCase() === 'Others' && categoryOtherRef.current) {
        categoryOtherRef.current.focus();
      }
      
    }

    useEffect(() => {
      if (isVisible && categoryOtherRef.current) {
        categoryOtherRef.current.focus();
      }
    }, [isVisible]);

    const handleFocus = () => {
      if (categoryOtherRef.current) {
        categoryOtherRef.current.focus();
      }
    };

    // useEffect(() => {
    //   if (isVisible && categoryOtherRef.current) {
    //     categoryOtherRef.current.focus();
    //   }
    // }, [isVisible]);

    
    


  return (

    <div>

      <Spin spinning={loading} size='large'>

        <div className="tab-pane" id="step4" role="tabpanel" aria-labelledby="nav-step4-tab">

        <div className='tabScroll'>

          <p><strong>Category<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></strong></p>

          <p>Will be shared with your employer</p>

          {

              result?.map((item, index) => (

                  <div id="category-acco" key={index}>

                      <div className="card">

                          <div className="card-header">

                              {/* <a className="btn" data-bs-toggle="collapse" aria-expanded="true" href="#collapseOne">

                                  {item?.category}
                              
                              </a> */}

                              <button className='btn' onClick={() => handleClick(index)}>
                                {item.category}
                                <span className='ml-2 mt-2'><i className={activeIndex === index ? "icon-keyboard_arrow_up" : "icon-keyboard_arrow_down"}></i></span>
                              </button>

                              <CustomCheckbox handleFocus={handleFocus} setCategory={setCategory} category={category} setIsVisible={setIsVisible} isVisible={isVisible} data={item.category} catId={item.id} />

                          </div>
                      
                          {/* <div className="collapse"> */}

                              <div className="card-body">
                          
                              {activeIndex === index && (
                                <div className={`accordion-content ${activeIndex === index ? 'active' : ''}`}>{item.description}</div>
                              )}

                              </div>

                          {/* </div> */}

                      </div>

                    {/* <button onClick={() => handleClick(index)}>
                      {item.category}
                    </button>
                    {activeIndex === index && (
                      <div className="accordion-content">{item.description}</div>
                    )} */}

                  </div>

              ))

          }

          {
              isVisible &&

              <div className="row mt-2">
                  
                <div className="col">
                    <label className="haveInfo">Other Category<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>
                    <input 
                      ref={categoryOtherRef}
                      type="text" 
                     // {...register('category_other')} 
                      style={{height: '65px', borderRadius: '7px', }}
                      className="form-control"
                      name='category_other'
                      maxLength={200}
                      onChange={(e) => CategoryHandler(e)}
                      
                    />
                  
                  </div>

              </div>

            }

          </div>

          <div className="row">

            <div className='col-md-6'>

              <div className="d-grid gap-2 mt-4 mb-4">

                  <button className="btn btn-primary btn-informant" 
                      type="submit" 
                      onClick={() => {
                          setNavTab(navTab - 2)
                          setCurrent(current - 2)
                      }}
                  >Back<i className="icon-arrow-left1"></i></button>

              </div>

            </div>

            <div className='col-md-6'>

              <div className="d-grid gap-2 mt-4 mb-4">
                
                <button className="btn btn-primary btn-informant gotoStp5" data-bs-target="#step5"  type="button" onClick={() => categorySubmit()}>Next <i className="icon-arrow-right1"></i></button>
                
              </div>

            </div>
          
          </div>

        </div>

      </Spin>

    </div>

  )

}

export default Step3